import { FC } from "react";
import { Button, HStack, Stack, Text } from "@chakra-ui/react";

import { useAppModal } from "../../Modals";
import { Info2Icon } from "../../../icons";
import { useGetDebtStateQuery } from "../../../../api/debt";
import { OverpaymentInfoModal } from "./OverpaymentInfoModal";
import { formatPriceWithoutZeros, isStringWithNumber } from "../../../../utils";

export const PaymentsScheduleOverpayment: FC = () => {
  const { showModal } = useAppModal();
  const { data } = useGetDebtStateQuery();

  const overpayment = isStringWithNumber(data?.overpaymentAmount) && Number(data?.overpaymentAmount) > 0
    ? formatPriceWithoutZeros(Number(data?.overpaymentAmount))
    : "";

  const onClick = () => {
    showModal({
      content: onClose => <OverpaymentInfoModal onClose={onClose} />,
    });
  };

  if (!overpayment) {
    return null;
  }

  return (
    <HStack
      p="17px"
      justifyContent="space-between"
      alignItems="flex-start"
      borderRadius="16px"
      bg="white"
    >
      <Stack spacing="7px" pt="2px" mb="3px">
        <Text lineHeight="16px">Аванс / Переплата</Text>
        <Text variant="brand" fontFamily="Normalidad Medium Var" lineHeight="16px">{overpayment}</Text>
      </Stack>

      <Button minW="20px" h="20px" p="0" colorScheme="transparent" onClick={onClick}>
        <Info2Icon />
      </Button>
    </HStack>
  );
};
